import { createFileRoute } from "@tanstack/react-router";
import {
  getAssetgroupsRetrieveQueryOptions,
  getAssetsAllAssetsListQueryOptions,
  getStatesListInfiniteQueryOptions,
} from "@/api/wai/wai3Api";
import { GrunndataAssetGroupDetail } from "@/components/System/GrunndataDetails";

function GrunndataAssetGroupIndexRoute() {
  const { systemName, assetGroupName } = Route.useParams();
  return <GrunndataAssetGroupDetail systemName={systemName} assetGroupName={assetGroupName} />;
}

export const Route = createFileRoute("/_auth/grunndata/$systemName/$assetGroupName/")({
  component: GrunndataAssetGroupIndexRoute,
  beforeLoad: ({ params }) => {
    return {
      getTitle: () => params.assetGroupName,
    };
  },
  loader: ({ context: { queryClient }, params: { assetGroupName } }) => {
    void queryClient.query(getAssetgroupsRetrieveQueryOptions(assetGroupName));
    void queryClient.fetchInfiniteQuery(
      getStatesListInfiniteQueryOptions({
        page_size: 20,
        order: ["-state"],
        assetGroup: [assetGroupName],
      }),
    );
    void queryClient.query(getAssetsAllAssetsListQueryOptions({ assetGroups: [assetGroupName] }));
  },
});
